import { ROLES_USER_TEAM } from '@/types/enum/constants'

const getIsUserTeams = (loggedUserRoles: string[]): boolean =>
  !!loggedUserRoles?.find(value => ROLES_USER_TEAM.find(role => role === value)) || false

export default getIsUserTeams
